import React from 'react';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Dropzone } from '../../../CommonComponents/OPL/Dropzone/Dropzone';
import { useDropzoneOptions } from '../../hooks/useDropzoneOptions';
import { useIsFolderReadOnly } from '../../hooks/useIsFolderReadOnly';

export const EntityListEmpty: React.FC = () => {
  const isFolderReadOnly = useIsFolderReadOnly();

  const dropZoneOptions = useDropzoneOptions();

  if (isFolderReadOnly) {
    return (
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    );
  }

  return (
    <Box p="24">
      <Dropzone options={dropZoneOptions} />
    </Box>
  );
};
